import "Layouts/default";
import "Pages/catalog/catalog";

import { scrollToEl } from "Functions/anchor";

import { processSubGroups } from "./catalog/catalog-jquery";

import "Ui/slider";
import "Ui/favorite-trigger";
import "Ui/tabs";

let customRecipesLocale;

const lang = document.querySelector("html").getAttribute("lang");
import(`Locale/${lang}.json`).then((module) => {
    customRecipesLocale = module.CustomRecipes;
});

for (const myRecipeRadio of document.querySelectorAll(
    '.js-filter-my-recipe-radios input[type="radio"]'
)) {
    myRecipeRadio.addEventListener("click", () => {
        scrollToEl(document.querySelector(".js-listing-scroll-here"), 20);
    });
}

const fakeSearch = document.querySelector(".js-recipes-fake-search");
const fakeSearchSubmit = document.querySelector(".js-recipes-fake-search-submit");
const fakeSearchSubmitFunction = () => {
    document.querySelector(".js-recipes-real-search").value = fakeSearch.value;
    window.Filter.submit();
    document.activeElement.blur();
    scrollToEl(document.querySelector(".js-listing-scroll-here"), 20);
};

if (fakeSearch) {
    fakeSearch.addEventListener("change", fakeSearchSubmitFunction);

    if (fakeSearchSubmit) {
        fakeSearchSubmit.addEventListener("click", (e) => {
            e.preventDefault();
            fakeSearchSubmitFunction();
        });
    }
}

for (const mostSearchedButton of document.querySelectorAll(".js-most-searched-button")) {
    mostSearchedButton.addEventListener("click", (event) => {
        event.preventDefault();

        document.querySelector(".js-recipes-search-input").value =
            event.currentTarget.dataset.value;
        document.querySelector(".js-recipes-search-form").submit();
    });
}

const searchReset = document.querySelector(".js-recipes-search-reset");
if (searchReset) {
    searchReset.addEventListener("click", (event) => {
        event.preventDefault();

        document.querySelector(".js-recipes-search-input").value = "";
        document.querySelector(".js-recipes-search-form").submit();
    });
}

// Filter form submissions - už nepotrebné, lebo buttony majú form="filter"
// a Filter objekt sa automaticky inicializuje na <form id="filter">
// Nechávame len pre prípad, že by sa niekto pokúsil submitnúť lokálny formulár
for (const filterForm of document.querySelectorAll(".js-recipes-filter-form")) {
    filterForm.addEventListener("submit", (event) => {
        event.preventDefault();
        // Zabráň submitu lokálneho formulára, buttony majú form="filter"
    });
}

// === RECIPE FILTER TABS LOGIC ===

const FILTER_TAB_IDS = [
    "recipes-filter-tab-categories",
    "recipes-filter-tab-main-ingredient",
    "recipes-filter-tab-occasions",
];

const recipeTabs = document.querySelector(".js-recipes-filter-tabs");
const resetBtn = document.querySelector(".js-reset-recipe-filters");

// Flag pre prevenciu viacnásobných fetch requestov počas resetu
let isResetting = false;

// Zistenie typu filtra z select elementu
function getFilterTypeFromSelect(select) {
    const name = select.name; // napr. "f[category][]" alebo "f[preparation_time]"
    const match = name.match(/f\[(\w+)\]/);
    return match ? match[1] : null;
}

// Zozbieranie hodnôt VŠETKÝCH filtrov z formulára
function collectFiltersFromTab(tabId) {
    const filters = {};
    const filterForm = document.querySelector(".js-recipes-filter-form");

    if (filterForm) {
        // Zbierať všetky selecty z formulára (hlavné + spoločné)
        filterForm.querySelectorAll("select").forEach((select) => {
            const filterType = getFilterTypeFromSelect(select);
            if (!filterType) return;

            const value = $(select).val();
            if (value && (Array.isArray(value) ? value.length > 0 : value !== "")) {
                filters[filterType] = value;
            }
        });
    }

    return filters;
}

/**
 * Zistí, či sú v danom tabe aktívne nejaké filtre (aspoň 1 vybratá hodnota)
 */
function tabHasActiveFilters(tabId) {
    const filters = collectFiltersFromTab(tabId);
    return Object.keys(filters).length > 0;
}

/**
 * Reset všetkých selectov vo formulári (hlavné + spoločné)
 */
function resetAllFilters() {
    const filterForm = document.querySelector(".js-recipes-filter-form");
    if (!filterForm) return;

    filterForm.querySelectorAll("select.js-dropdown-multiselect").forEach((select) => {
        const $select = $(select);
        if (!$select.data("multiselect")) return;

        // ak existuje prázdna option (value=""), nastav ju
        if ($select.find("option:selected").length) {
            $select.find("option:selected").each(function () {
                $(this).prop("selected", false);
            });
        }

        $select.multiselect("refresh");
        $select.trigger("change");
    });
}

/**
 * Skryje/zobrazí reset button podľa toho, či má aktuálny tab aktívne filtre
 */
function updateResetButtonVisibility(tabId) {
    if (!resetBtn) return;
    resetBtn.classList.toggle("hidden", !tabHasActiveFilters(tabId));
}

/**
 * Vráti id aktuálne aktívneho tabu (len z FILTER_TAB_IDS)
 */
function getActiveFilterTabId() {
    if (!recipeTabs) return null;
    const activeTabId = recipeTabs.activeTabs?.[0];
    return FILTER_TAB_IDS.includes(activeTabId) ? activeTabId : null;
}

// Fetch filter options a aktualizácia UI
async function fetchAndUpdateFilters(tabId, modifiedFilter = null) {
    const filters = collectFiltersFromTab(tabId);

    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(filters)) {
        if (Array.isArray(value)) {
            value.forEach((v) => params.append(`f[${key}][]`, v));
        } else {
            params.append(`f[${key}]`, value);
        }
    }
    if (modifiedFilter) {
        params.append("modified", modifiedFilter);
    }

    try {
        const response = await fetch(`/fetch-recipe-filters?${params}`);
        const result = await response.json();

        if (result) {
            // Aktualizovať počet v tlačidle
            updateSubmitButtonCount(tabId, result.count);

            // Aktualizovať dostupné filtre (disable neplatné options)
            updateAvailableFilters(tabId, result.filters, modifiedFilter);
        }
    } catch (error) {
        console.error("Failed to fetch filter options:", error);
    } finally {
        // po každom fetchi skús aktualizovať reset button
        updateResetButtonVisibility(tabId);
    }
}

// Aktualizácia počtu v submit tlačidle
function updateSubmitButtonCount(tabId, count) {
    const filterForm = document.querySelector(".js-recipes-filter-form");
    if (!filterForm) return;

    const submitButton = filterForm.querySelector(".js-recipes-filter-trigger");
    if (submitButton && customRecipesLocale) {
        submitButton.textContent = customRecipesLocale.search + ` (${count})`;
    }
}

// Extrakcia dostupných hodnôt z rôznych formátov API response
// Vracia pole objektov {value, text} pre konzistentné spracovanie
function extractAvailableOptions(filterData, filterType) {
    if (!filterData) return [];

    // Pole objektov s id a type: [{id: 7, type: "special"}]
    if (Array.isArray(filterData)) {
        // Ak je to pole stringov (preparation_time), vrátime value=text
        if (filterData.length > 0 && typeof filterData[0] === "string") {
            return filterData.map((item) => ({ value: String(item), text: String(item) }));
        }
        // Pole objektov s id
        return filterData.map((item) => {
            if (typeof item === "object" && item.id !== undefined) {
                return { value: String(item.id), text: item.value || String(item.id) };
            }
            return { value: String(item), text: String(item) };
        });
    }

    // Objekt s key-value: {1: "jesetera", 34: "krevety"} alebo {0: "00:45:00"}
    if (typeof filterData === "object") {
        // Pre preparation_time - hodnoty sú option values (00:45:00)
        if (filterType === "preparation_time") {
            return Object.values(filterData).map((val) => ({
                value: String(val),
                text: String(val),
            }));
        }
        // Pre ostatné (main_ingredient) - kľúče sú option values
        return Object.entries(filterData).map(([key, val]) => ({
            value: String(key),
            text: String(val),
        }));
    }

    return [];
}

// Build tree structure from flat category array using parent_id
function buildCategoryTree(categories) {
    if (!Array.isArray(categories) || categories.length === 0) return [];

    // Index by id
    const indexed = {};
    categories.forEach((cat) => {
        indexed[cat.id] = { ...cat, children: [] };
    });

    const tree = [];

    // Build tree using parent_id
    Object.values(indexed).forEach((cat) => {
        if (!cat.parent_id) {
            tree.push(cat);
        } else if (indexed[cat.parent_id]) {
            indexed[cat.parent_id].children.push(cat);
        } else {
            // Parent not in list, treat as root
            tree.push(cat);
        }
    });

    // Sort by sort field
    const sortNodes = (nodes) => {
        nodes.sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0));
        nodes.forEach((node) => {
            if (node.children.length > 0) {
                sortNodes(node.children);
            }
        });
    };
    sortNodes(tree);

    return tree;
}

// Rebuild category select structure based on API hierarchy
function rebuildCategorySelect($select, categoryData) {
    if (!Array.isArray(categoryData) || categoryData.length === 0) return;

    const tree = buildCategoryTree(categoryData);
    const currentValues = $select.val() || [];

    // Clear existing options except empty option
    $select.find("option").not('[value=""]').remove();
    $select.find("optgroup").remove();

    // Helper to create option
    const createOption = (cat, level) => {
        // Level 0 items should NOT have data-has-children=true, because their children
        // are in the same optgroup (controlled by optgroup caret), not a sub-group
        const hasChildren = level > 0 && cat.children.length > 0;

        const $option = $("<option>")
            .val(cat.id)
            .text(cat.name)
            .attr("data-level", level)
            .attr("data-has-children", hasChildren ? "true" : "false");

        if (currentValues.includes(String(cat.id))) {
            $option.prop("selected", true);
        }
        return $option;
    };

    // Helper to add children recursively
    const addChildren = ($parent, children, level) => {
        children.forEach((child) => {
            $parent.append(createOption(child, level));
            if (child.children.length > 0) {
                addChildren($parent, child.children, level + 1);
            }
        });
    };

    // Build select structure - ALL root categories get optgroups for consistency
    tree.forEach((rootCat) => {
        const $optgroup = $("<optgroup>").attr("label", rootCat.name);
        // Add the root category itself as level 0
        $optgroup.append(createOption(rootCat, 0));
        // Add all descendants if any
        if (rootCat.children.length > 0) {
            addChildren($optgroup, rootCat.children, 1);
        }
        $select.append($optgroup);
    });

    // Rebuild multiselect
    $select.multiselect("rebuild");
    processSubGroups($select);

    // Hide caret for optgroups without children (only have the level-0 item)
    const $container = $select.next().find("ul.multiselect-container");
    $container.find("li.multiselect-group").each(function () {
        const $groupLi = $(this);
        const $children = $groupLi.nextUntil("li.multiselect-group");
        // If only 1 child (the level-0 item itself), hide the caret
        if ($children.length <= 1) {
            $groupLi.find(".caret-container").hide();
        }
    });
}

// Aktualizácia dostupných hodnôt vo VŠETKÝCH filtroch
function updateAvailableFilters(tabId, availableFilters, modifiedFilter) {
    const filterForm = document.querySelector(".js-recipes-filter-form");
    if (!filterForm) return;

    // Aktualizovať všetky selecty vo formulári (nie len v aktívnom tabe)
    filterForm.querySelectorAll("select.js-dropdown-multiselect").forEach((select) => {
        const filterType = getFilterTypeFromSelect(select);

        if (!filterType || filterType === modifiedFilter) return;

        const $select = $(select);

        // Special handling for category - rebuild structure based on parent_id
        if (filterType === "category" && Array.isArray(availableFilters[filterType])) {
            rebuildCategorySelect($select, availableFilters[filterType]);
            return; // rebuildCategorySelect handles everything
        }

        const availableOptions = extractAvailableOptions(availableFilters[filterType], filterType);
        const availableValues = availableOptions.map((opt) => opt.value);

        // Disable options ktoré nie sú v available
        $select.find("option").each(function () {
            const $option = $(this);
            const value = $option.val();

            if (!value) return; // skip empty option

            const isAvailable = availableValues.includes(value);
            $option.prop("disabled", !isAvailable);
        });

        $select.multiselect("rebuild");

        // Fix bootstrap-multiselect bug: when all options in an optgroup are disabled,
        // the plugin incorrectly marks the optgroup as checked/active (vacuous truth).
        const $container = $select.next().find("ul.multiselect-container");
        $container.find("li.multiselect-group").each(function () {
            const $groupLi = $(this);
            const $allSiblings = $groupLi.nextUntil("li.multiselect-group");

            // Only count items that actually belong to this optgroup:
            // 1. Items with multiselect-collapsible-hidden (collapsed children)
            // 2. The is-level-0 item immediately after header (main category option)
            const $optgroupChildren = $allSiblings.filter(function () {
                const $this = $(this);
                // Collapsed children always have this class
                if ($this.hasClass("multiselect-collapsible-hidden")) return true;
                // The main category option (is-level-0) right after the header
                if ($this.hasClass("is-level-0") && $this.prev().is($groupLi)) return true;
                // Items that are direct children (level > 0) of the optgroup
                // Check if this item follows the is-level-0 without encountering another is-level-0
                const $prevLevel0 = $this.prevAll(".is-level-0").first();
                if (
                    $prevLevel0.length &&
                    $prevLevel0.prevAll("li.multiselect-group").first().is($groupLi)
                ) {
                    return true;
                }
                return false;
            });

            const $nonDisabledOptions = $optgroupChildren
                .not(".disabled")
                .not(".multiselect-filter-hidden");
            if ($nonDisabledOptions.length === 0) {
                $groupLi.addClass("disabled");
                $groupLi.removeClass("active");
                const $groupInput = $groupLi.find('input[type="checkbox"]');
                $groupInput.prop("checked", false);
                $groupInput.prop("disabled", true);
            }
        });

        processSubGroups($select);

        // Mark disabled sub-group headers that have at least one enabled child
        const $subContainer = $select.next().find("ul.multiselect-container");
        $subContainer.find("li.multiselect-sub-group.disabled").each(function () {
            const $subGroupLi = $(this);
            const subVal = $subGroupLi.find('input[type="checkbox"]').val();
            const subRawLevel = $select.find(`option[value="${subVal}"]`).data("level");
            const subLevel = subRawLevel !== undefined ? parseInt(subRawLevel) : 1;

            let hasActiveChild = false;
            let $next = $subGroupLi.next();
            while ($next.length && !$next.hasClass("multiselect-group")) {
                const nextVal = $next.find('input[type="checkbox"]').val();
                const nextRawLevel = $select.find(`option[value="${nextVal}"]`).data("level");
                const nextLevel = nextRawLevel !== undefined ? parseInt(nextRawLevel) : 1;
                if (nextLevel <= subLevel) break;
                if (!$next.hasClass("disabled") && !$next.hasClass("is-level-0")) {
                    hasActiveChild = true;
                    break;
                }
                $next = $next.next();
            }

            $subGroupLi.toggleClass("has-active-child", hasActiveChild);
        });
    });
}

// Klik na reset -> resetne VŠETKY filtre + refetch
if (resetBtn) {
    resetBtn.addEventListener("click", async (e) => {
        e.preventDefault();

        const activeTabId = getActiveFilterTabId();
        if (!activeTabId) return;

        // Nastav flag na prevenciu viacnásobných fetchov
        isResetting = true;

        // Reset všetkých filtrov (hlavné + spoločné)
        resetAllFilters(activeTabId);

        // Natiahni default counts/available options pre čistý stav
        await fetchAndUpdateFilters(activeTabId, null);

        // Resetuj flag
        isResetting = false;

        window.Filter.submit();
    });
}

if (recipeTabs) {
    const filterForm = document.querySelector(".js-recipes-filter-form");

    recipeTabs.addEventListener("rTab.after.openTab", async () => {
        const activeTabId = recipeTabs.activeTabs[0];

        if (FILTER_TAB_IDS.includes(activeTabId)) {
            // Pridaj .is-active classu na formulár (zobrazí ho)
            if (filterForm) {
                filterForm.classList.add("is-active");
            }

            // Nastav flag na prevenciu viacnásobných fetchov
            isResetting = true;

            // Automatický reset všetkých filtrov pri prepnutí tabu
            resetAllFilters(activeTabId);

            // Fetch dostupných hodnôt pre čistý stav
            await fetchAndUpdateFilters(activeTabId);

            // Resetuj flag
            isResetting = false;
        } else {
            // Search tab - skry formulár
            if (filterForm) {
                filterForm.classList.remove("is-active");
            }

            if (resetBtn) {
                resetBtn.classList.add("hidden");
            }
        }
    });

    // 2) Pri zmene AKÉHOKOĽVEK filtra - fetch nových hodnôt
    if (filterForm) {
        filterForm.querySelectorAll("select").forEach((select) => {
            $(select).on("change", () => {
                // Preskočiť fetch počas resetu (predídeme viacnásobným API volám)
                if (isResetting) return;

                const activeTabId = getActiveFilterTabId();
                if (!activeTabId) return;

                const modifiedFilter = getFilterTypeFromSelect(select);
                fetchAndUpdateFilters(activeTabId, modifiedFilter);
            });
        });
    }

    // Initial state (po load-e)
    const initialTabId = getActiveFilterTabId();
    if (initialTabId) {
        // Ak je filter tab aktívny, pridaj .is-active
        if (filterForm) {
            filterForm.classList.add("is-active");
        }
        updateResetButtonVisibility(initialTabId);
    } else {
        // Search tab je aktívny, skry formulár
        if (filterForm) {
            filterForm.classList.remove("is-active");
        }
        if (resetBtn) {
            resetBtn.classList.add("hidden");
        }
    }
}
